import { FileFormat, getFileFormat } from "utils/getFileFormat";

export const WORDLESS_DOCUMENT_TOOLTIP =
  "This document has no words and cannot be used to generate a report.";

export const isDocumentWordless = (doc) => {
  if (doc?.wordCount !== 0) {
    return false;
  }
  return getFileFormat(doc.name) !== FileFormat.EXCEL;
};
